import { Box, CircularProgress, Grid2 } from "@mui/material";
import styles from "./CreateAccountStyles.module.scss";
import CustomInput from "../../../../GlobalComponents/CustomInput/CustomInput";
import CheckBoxOutlineBlankIcon from "@mui/icons-material/CheckBoxOutlineBlank";
import CheckBoxIcon from "@mui/icons-material/CheckBox";
import CustomButton from "../../../../GlobalComponents/CustomButton/CustomButton";
import VerifiedIcon from "@mui/icons-material/Verified";
import { useNavigate } from "react-router-dom";
import ReCAPTCHA from "react-google-recaptcha";

function CreateAccount({
  formFieldUpdate,
  name,
  phoneNumber,
  email,
  password,
  errors,
  errorMessage,
  otp,
  setOtp,
  handleOtpChange,
  handleOtpKeyDown,
  inputRefs,
  isOtpSent,
  sendOtp,
  resendOtp,
  otpError,
  verifyAccount,
  isCreateOrg,
  verifyError,
  emailError,
  verifying,
  country,
  onChange,
  recaptcha,
  resendLoading,
  isChecked,
  setIsChecked,
  resendMessage,
  phoneNumberformat,
}) {
  const navigate = useNavigate();
  const recaptchaStatus = process.env.REACT_APP_RECAPTCHA_LOGIN;
  const recaptchSiteKey = process.env.REACT_APP_RECAPTCHA_SITE_KEY;

  const handleCheckboxChange = () => {
    if (!isOtpSent) {
      setIsChecked((prev) => !prev);
    }
  };

  return (
    <Grid2 className={styles.createAccountContainer}>
      <Grid2 className={styles.createContainer}>
        <Grid2 className={styles.label20}>Create an Account</Grid2>
        {!isCreateOrg && (
          <Grid2 className={styles.signIn}>
            <Grid2 className={styles.label14}>Have an Account?</Grid2>
            <Grid2
              className={styles.signInLabel}
              onClick={() => {
                navigate(`/login`);
              }}
            >
              Sign in
            </Grid2>
          </Grid2>
        )}
      </Grid2>
      <hr className={styles.line} />
      {!isCreateOrg ? (
        <>
          <Grid2 className={styles.nameContainer}>
            <CustomInput
              title="Full Name"
              placeholder="John Doe"
              value={name}
              setValue={(e) => formFieldUpdate("name", e)}
              error={verifyError && errors.name}
              errorMessage={verifyError && errorMessage.name}
              disabled={isOtpSent}
              fontSize={true}
            />
            <CustomInput
              title="Phone Number"
              placeholder={
                country === "India" ? "99999-99999" : "(999) 999-9999"
              }
              value={phoneNumberformat(phoneNumber, country)}
              setValue={(e, _, event) => {
                let newValue = e.replace(/\D/g, "");

                // Handle backspace
                if (event.nativeEvent.inputType === "deleteContentBackward") {
                  if (country === "USA") {
                    if (newValue.endsWith(") ") || newValue.endsWith("-")) {
                      newValue = newValue.slice(0, -1);
                    }
                  } else if (country === "India") {
                    if (newValue.endsWith("-")) {
                      newValue = newValue.slice(0, -1);
                    }
                  }
                } else {
                  if (country === "USA") {
                    newValue = newValue.substring(0, 10);
                    if (newValue.length >= 1) {
                      newValue = "(" + newValue;
                    }
                    if (newValue.length >= 4) {
                      newValue =
                        newValue.substring(0, 4) + ") " + newValue.substring(4);
                    }
                    if (newValue.length >= 9) {
                      newValue =
                        newValue.substring(0, 9) + "-" + newValue.substring(9);
                    }
                  } else if (country === "India") {
                    newValue = newValue.substring(0, 10);
                    if (newValue.length >= 6) {
                      newValue =
                        newValue.substring(0, 5) + "-" + newValue.substring(5);
                    }
                  }
                }

                formFieldUpdate("phoneNumber", newValue);
              }}
              error={verifyError && errors.phoneNumber}
              errorMessage={verifyError && errorMessage.phoneNumber}
              disabled={isOtpSent}
              fontSize={true}
            />
          </Grid2>
          <Grid2 className={styles.fieldsGap}>
            <CustomInput
              title="Email"
              value={email.toLowerCase()}
              placeholder="john@company.com"
              setValue={(e) => formFieldUpdate("email", e)}
              error={(verifyError || emailError) && errors.email}
              errorMessage={(verifyError || emailError) && errorMessage.email}
              disabled={isOtpSent}
              fontSize={true}
            />
          </Grid2>
          <Grid2 className={styles.fieldsGap}>
            <CustomInput
              title="Password"
              placeholder="Enter your password"
              value={password}
              setValue={(e) => formFieldUpdate("password", e)}
              password={true}
              passwordview={true}
              error={verifyError && errors.password}
              errorMessage={verifyError && errorMessage.password}
              disabled={isOtpSent}
              fontSize={true}
            />
          </Grid2>
          <Grid2 className={styles.privacyContainer}>
            {isChecked ? (
              <CheckBoxIcon
                onClick={handleCheckboxChange}
                sx={{ color: "#135fc2" }}
              />
            ) : (
              <CheckBoxOutlineBlankIcon
                onClick={handleCheckboxChange}
                sx={{
                  color: verifyError && !isChecked ? "#ae1b17" : "#135fc2",
                }}
              />
            )}
            <Grid2 className={styles.label14}>
              I agree with the{" "}
              <span
                className={styles.serviceLabel}
                onClick={() =>
                  window.open(
                    "https://roconpaas.com/terms-of-service/",
                    "_blank"
                  )
                }
              >
                Terms of Services
              </span>{" "}
              and{" "}
              <span
                className={styles.serviceLabel}
                onClick={() =>
                  window.open("https://roconpaas.com/privacy-policy/", "_blank")
                }
              >
                Privacy Policy
              </span>
            </Grid2>
          </Grid2>
          {!isOtpSent ? (
            recaptchaStatus === "true" && (
              <>
                <Grid2 className={styles.recaptch}>
                  <ReCAPTCHA sitekey={recaptchSiteKey} onChange={onChange} />
                </Grid2>
                {verifyError && !recaptcha && (
                  <Grid2 className={styles.error}>
                    Please verify you are not a robot
                  </Grid2>
                )}
              </>
            )
          ) : (
            <Grid2 className={styles.otpMainContainer}>
              <span className={styles.otpLabel}>Enter OTP</span>
              <Grid2 className={styles.otpContainer}>
                <Box className={styles.verificationContainer}>
                  {otp.map((digit, index) => (
                    <input
                      key={index}
                      className={`${styles.otpInput} ${
                        otpError && styles.otpError
                      }`}
                      type="text"
                      maxLength={1}
                      value={digit}
                      onChange={(e) => handleOtpChange(index, e.target.value)}
                      onKeyDown={(e) => handleOtpKeyDown(index, e)}
                      ref={(el) => (inputRefs.current[index] = el)}
                      onInput={(e) => {
                        e.target.value = e.target.value.replace(/\D/g, "");
                      }}
                      onPaste={(e) => {
                        e.preventDefault();
                        const pasteData = e.clipboardData
                          .getData("text")
                          .trim();
                        if (/^\d+$/.test(pasteData)) {
                          const digits = pasteData.slice(0, 6).split("");
                          const updatedOtp = [...otp];
                          digits.forEach((digit, i) => {
                            if (index + i < 6) {
                              updatedOtp[index + i] = digit;
                            }
                          });
                          setOtp(updatedOtp);
                          const nextIndex = Math.min(index + digits.length, 5);
                          inputRefs.current[nextIndex]?.focus();
                        }
                      }}
                    />
                  ))}
                </Box>
                <Grid2 className={styles.resendOtp} onClick={resendOtp}>
                  {resendLoading ? (
                    <CircularProgress color="inherit" size={20} />
                  ) : (
                    "Resend OTP"
                  )}
                </Grid2>
              </Grid2>
              {otpError && <Grid2 className={styles.error}>{otpError}</Grid2>}
              {resendMessage && (
                <Grid2 className={styles.resendOtpMsg}>{resendMessage}</Grid2>
              )}
              <Grid2 className={styles.otpText}>
                Enter 6-digit OTP sent to{" "}
                <span className={styles.emailText}>{email}</span>
              </Grid2>
            </Grid2>
          )}

          <Grid2 className={styles.fieldsGap}>
            <CustomButton onClick={!isOtpSent ? sendOtp : verifyAccount}>
              {verifying ? (
                <CircularProgress color="inherit" size={20} />
              ) : isOtpSent ? (
                "Verify"
              ) : (
                "Verify Your Account"
              )}
            </CustomButton>
          </Grid2>
        </>
      ) : (
        <>
          <Grid2 className={styles.verifiedName}>
            <Grid2 className={styles.textContainer}>
              <Grid2 className={styles.label16}>Full Name</Grid2>
              <Grid2 className={styles.label14}>{name}</Grid2>
            </Grid2>
            <Grid2>
              <Grid2 className={styles.label16}>Email</Grid2>
              <Grid2 className={styles.label14}>{email}</Grid2>
            </Grid2>
          </Grid2>
          <Grid2 className={styles.verified}>
            <VerifiedIcon /> <span>Account is verified</span>
          </Grid2>
        </>
      )}
    </Grid2>
  );
}

export default CreateAccount;
